import { constant } from "../constant";
import React, { createContext, useContext, useEffect, useState } from "react";
import { getApi } from "common/services/api";
import { getDataFromStorage } from "common/utils/storage";
import qs from "qs";
import axios from "axios";
const SSOContext = createContext();

export const SSOProvider = ({ children }) => {
  const [codeVerifier, setCodeVerifier] = useState("");
  const [intervalId, setIntervalId] = useState();

  useEffect(() => {
    const localCodeVerifier = getDataFromStorage(constant.codeVerifier);
    if (localCodeVerifier) {
      setCodeVerifier(localCodeVerifier);
    }
  });
  // Function to fetch a new access token

  const fetchAccessToken = (refreshToken, authCode) => {
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: constant.clientID,
      code: authCode,
      scope: constant.scope,
      refresh_token: refreshToken,
    });

    const config = {
      method: "post",
      url: constant.authCodeUrl,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // Security: do not persist Outlook tokens in browser storage.
        // Token refresh is handled server-side using the refresh token stored securely in DB.
        void response;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  function callFetchToken() {
    // Deprecated: client-side token refresh is intentionally disabled.
    // Outlook access is handled server-side; keep this as a no-op for compatibility.
    if (intervalId) clearInterval(intervalId);
    setIntervalId(undefined);
  }
  const setCodeVerifierValue = (value) => {
    setCodeVerifier(value);
  };
  const valueToPass = {
    codeVerifier,
    intervalId,
    callFetchToken,
    setCodeVerify: setCodeVerifierValue,
  };
  return (
    <SSOContext.Provider value={valueToPass}>{children}</SSOContext.Provider>
  );
};

// Custom hook to access user data
export const SSORole = () => useContext(SSOContext);
